export const defaultSalesTableHeader = (selectedOption) => {
	if (selectedOption === 'Sales_Item_Location_Store') {
		return [
			{
				id: 'store',
				dataKey: 'store',
				label: 'Store',
				children: [],
				align: 'left',
				sortable: false,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'netSales',
				dataKey: 'netSales',
				label: 'Net Sales',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'channelPerformance',
				dataKey: 'channelPerformance',
				label: 'Channel Performance',
				children: [
					{
						id: 'pickup',
						dataKey: 'pickup',
						label: 'PU',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
					{
						id: 'delivery',
						dataKey: 'delivery',
						label: 'DLV',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
					{
						id: 'bis',
						dataKey: 'bis',
						label: 'BIS',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
					{
						id: 'sfs',
						dataKey: 'sfs',
						label: 'SFS',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
				],
				align: 'center',
				sortable: false,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'inventory',
				dataKey: 'inventory',
				label: 'Inventory',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'inStock',
				dataKey: 'inStock',
				label: 'Repl Instock(%)',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'nilPickRate',
				dataKey: 'nilPickRate',
				label: 'Nil Pick Rate(%)',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
		];
	} else if (selectedOption === 'Sales_Item_Location_State') {
		return [
			{
				id: 'state',
				dataKey: 'state',
				label: 'State',
				children: [],
				align: 'left',
				sortable: false,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'netSales',
				dataKey: 'netSales',
				label: 'Net Sales',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'channelPerformance',
				dataKey: 'channelPerformance',
				label: 'Channel Performance',
				children: [
					{
						id: 'pickup',
						dataKey: 'pickup',
						label: 'PU',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
					{
						id: 'delivery',
						dataKey: 'delivery',
						label: 'DLV',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
					{
						id: 'bis',
						dataKey: 'bis',
						label: 'BIS',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
					{
						id: 'sfs',
						dataKey: 'sfs',
						label: 'SFS',
						children: [],
						align: 'center',
						sortable: false,
						visibleIn: ['Store', 'Omni', 'eCom'],
					},
				],
				align: 'center',
				sortable: false,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'inventory',
				dataKey: 'inventory',
				label: 'Inventory',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'inStock',
				dataKey: 'inStock',
				label: 'Repl Instock(%)',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
			{
				id: 'nilPickRate',
				dataKey: 'nilPickRate',
				label: 'Nil Pick Rate(%)',
				children: [],
				align: 'right',
				sortable: true,
				visibleIn: ['Store', 'Omni', 'eCom'],
			},
		];
	} else {
		return [];
	}
};
